// Copyright (c) 2016 Deere & Company

import './non-editable-other-credit-panel.scss';
import React, {PropTypes} from 'react';
import ClaimOtherCredit from '@deere/cps-it.warranty-model-factory/lib/claim-item-other-credit';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledNumber from '../../../../shared/components/labeled-number';
import LabeledString from '../../../../shared/components/labeled-string';

const NonEditableOtherCreditPanel = props =>
    <section className='non-editable-other-credit-panel'>
        <h3>{props.credit.details.value}</h3>
        <div className='other-credit-panel-row'>
            <LabeledString
                className='lost-three-column'
                data={props.credit.comments}
                label='COMMENTS'
            />
            <LabeledCurrency
                className='value'
                data={props.credit.otherCreditAmount}
                label='VALUE'
            />
        </div>
        <div className='other-credit-panel-row'>
            <LabeledCurrency
                className='amount'
                data={props.credit.amount}
                label='AMOUNT'
            />
            <LabeledNumber
                className='distance'
                data={props.credit.distance}
                label={props.distanceColumnLabel}
            />
            <LabeledCurrency
                className='tax'
                data={props.credit.taxAmount}
                label='TAX'
            />
            <LabeledCurrency
                className='reimbursed'
                data={props.credit.reimbursementAmount}
                label='REIMBURSED'
            />
        </div>
    </section>;

NonEditableOtherCreditPanel.displayName = 'NonEditableOtherCreditPanel';
NonEditableOtherCreditPanel.propTypes = {
    credit: PropTypes.instanceOf(ClaimOtherCredit).isRequired,
    distanceColumnLabel: PropTypes.string.isRequired,
    highlightClass: PropTypes.string
};

export default NonEditableOtherCreditPanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/other-credits-panel/non-editable-other-credits-panel.js